import React from 'react';
import { T } from '../../../../common/locale/translate';

const InterchangesAlert = () => (
  <span className="interchanges-alert">
    <span className="fa fa-exclamation-circle" />
    <span className="mobile-text">{T('interchange')}</span>
    <span className="tooltip">
      <span className="arrow-left" />
      <span className="text">{T('interchanges_included')}</span>
      <span className="arrow-right" />
    </span>
  </span>
);

export default InterchangesAlert;



// WEBPACK FOOTER //
// ./app/javascript/common/components/interchanges_alert.jsx